// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"8974f22b","425":"06f5b684","510":"15a8038e","532":"414d80e7","633":"26d15c75","634":"d266c08f","922":"ec50659e","937":"50ffbeaf","972":"cdb96093"}[chunkId] + ".chunk.js";
};